﻿import { ApiResourceFactory } from '../api.resource.factory'
import { ScriptModel, ScriptGuidModel, ScriptStatusModel, ScriptResultModel } from '../api.models'
import { LoginService } from './api.login.service'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IScriptsService {
    getScripts(): ng.IPromise<any>
    scriptStart(model: ScriptModel): ng.IPromise<ScriptGuidModel>
    scriptStop(guid: any): ng.IPromise<ScriptGuidModel>
    scriptStatus(guid: any): ng.IPromise<ScriptStatusModel>
    getScriptResult(guid: any): ng.IPromise<ScriptResultModel>
}

export class ScriptsService implements IScriptsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getScripts(state: any = {}) {
        var get = this.apiResource.scripts.get
        state.request = get()
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    scriptStart(model: ScriptModel) {
        return this.apiResource.scripts['scriptStart'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    scriptStop(guid: string) {
        return this.apiResource.scripts['scriptStop'](guid).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    scriptStatus(guid: any) {
        return this.apiResource.scripts['scriptStatus'](guid).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getScriptResult(guid: any) {
        return this.apiResource.scripts['getScriptResult'](guid).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
